import { render } from "./Hamburger.vue?vue&type=template&id=4d6bf83b&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"

import "./Hamburger.vue?vue&type=style&index=0&id=4d6bf83b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6bf83b"]])

export default __exports__